import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import pt from 'vuetify/src/locale/pt.ts'

Vue.use(Vuetify)

const vuetify = new Vuetify({
  lang: {
    locales: { pt },
    current: 'pt'
  },
  theme: {
    themes: {
      light: {
        primary: '#004A93',
        secondary: '#00B01A',
        anchor: '#707070',
        success: '#00B01A',
        error: '#7c3232',
        blue: '#004A93'
      },
      dark: {
        // primary: '#004A93'
      }
    }
  }
})

export default vuetify



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js